import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus' // 修正拼写错误，将 ElemetPlus 改为 ElementPlus
import 'element-plus/dist/index.css'
// 若没有类型声明文件，可添加以下声明
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'


const pinia = createPinia()

createApp(App).use(pinia).use(store).use(router).use(ElementPlus).use(VueVideoPlayer).mount('#app') // 使用 VueDplayer
